'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _reactWindow = require('react-window');

var _BaseFilter2 = require('../base/BaseFilter');

var _BaseFilter3 = _interopRequireDefault(_BaseFilter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrapListFilter = function (_BaseFilter) {
    (0, _inherits3.default)(WrapListFilter, _BaseFilter);

    function WrapListFilter(props) {
        (0, _classCallCheck3.default)(this, WrapListFilter);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WrapListFilter.__proto__ || (0, _getPrototypeOf2.default)(WrapListFilter)).call(this, props));

        _this.calculateHeight = function () {
            var _this$props = _this.props,
                height = _this$props.height,
                itemHeight = _this$props.itemHeight,
                maxItems = _this$props.maxItems;
            var options = _this.state.options;

            if (height === 'auto') {
                return maxItems ? itemHeight * Math.min(options.length || 0, maxItems) : itemHeight * (options.length || 0);
            }
            return height;
        };

        _this.state.prevProps = props;
        _this.state.options = props.options || [];
        _this.itemRenderer = _this.itemRenderer.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(WrapListFilter, [{
        key: 'itemRenderer',
        value: function itemRenderer(_ref) {
            var index = _ref.index,
                style = _ref.style;
            var itemRenderer = this.props.itemRenderer;
            var options = this.state.options;

            return itemRenderer && itemRenderer(style, index, options);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(value) {
            var _props = this.props,
                options = _props.options,
                filterProperties = _props.filterProperties;

            var newOptions = _BaseFilter3.default.filterString(options, value, filterProperties);
            this.setState({
                filterText: value,
                options: newOptions
            });
        }
    }, {
        key: 'renderComponent',
        value: function renderComponent() {
            var _props2 = this.props,
                className = _props2.className,
                style = _props2.style,
                width = _props2.width,
                itemHeight = _props2.itemHeight,
                buffer = _props2.buffer;
            var options = this.state.options;

            return _react2.default.createElement(
                _reactWindow.VariableSizeList,
                {
                    style: style,
                    className: className,
                    overscanCount: buffer,
                    width: width,
                    height: this.calculateHeight(),
                    itemCount: options ? options.length : 0,
                    itemSize: function itemSize() {
                        return itemHeight;
                    }
                },
                this.itemRenderer
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            var isOptionsChanged = !(0, _immutable.List)(prevState.prevProps.options || []).equals((0, _immutable.List)(nextProps.options || []));

            if (isOptionsChanged) {
                return {
                    prevProps: nextProps,
                    options: _BaseFilter3.default.filterString(nextProps.options, prevState.filterText, nextProps.filterProperties)
                };
            }

            return null;
        }
    }]);
    return WrapListFilter;
}(_BaseFilter3.default);

WrapListFilter.defaultProps = (0, _extends3.default)({}, _BaseFilter3.default.defaultProps || {}, {
    className: '',
    width: '100%',
    height: 300,
    buffer: 10,
    itemHeight: 30,
    filterProperties: ['label']
});

exports.default = WrapListFilter;